<template>
    <div>
        <div v-if="this.logginIn">
            <v-progress-linear
                indeterminate
                color="primary"
                height="2">
            </v-progress-linear>
        </div>
        <v-container v-else>
            <v-row>
                <v-col cols="12" align="center">
                    <div class="toolbar-title">PERFECTA INLOGGNINGSPORTAL</div>
                </v-col>
            </v-row>
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="1" class="login-label">
                    <label>Email</label>
                </v-col>
                <v-col cols="4">
                    <input type="email" v-model="username" required :class="{alert: missingUser}">
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="1" class="login-label">
                    <label>Lösenord</label>
                </v-col>
                <v-col cols="4">
                    <input type="password" v-model="password" required :class="{alert: missingPass}">
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="1">
                    <v-btn @click="login()">Logga in</v-btn>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-container>
        <div class="footer" style="margin-top:25px">
            <span class="version">v. {{ version }}</span>
            <span class="powered-by">
                <span class="bollar-container">
                    <a href="https://www.coredination.se/"><img class="bollar" src="/img/bollar.png"/></a>
                </span>
                <span>
                    <a href="https://www.coredination.se/">Powered by Coredination</a>
                </span>
            </span>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    'name': 'Login',
    props: {},
    mounted() {

    },
    data: () => ({
        username: '',
        password: '',
        logginIn: false,
        missingPass: false,
        missingUser: false
    }),
    methods: {
        login() {
            if (this.password && this.username) {
                this.logginIn = true;
                let credentials = {
                    user: this.username,
                    pass: this.password
                }
                this.$api.post('login/', credentials)
                    .then(response => {
                        this.$api.setupCommonHeaders(response.data.token);
                        Vue.prototype.$me = response.data.me;
                        Vue.prototype.$customer = response.data.customer;
                        Vue.prototype.$assets = response.data.assets;
                        Vue.prototype.$forms = response.data.forms;
                        let customer = response.data.customer;
                        this.$router.push({ name: 'Customer', params: { id: customer.id }});
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.logginIn = false;
                    })
            } else {
                this.missingPass = !this.password;
                this.missingUser = !this.username
                console.log('missing credentials');
            }
        }
    },
    computed: {
        version() {
            return this.$version;
        }
    },
    components: {

    }
}
</script>

<style lang="scss" scoped>
    .login-label {
        text-align: right;
    }
    input {
        border-style: solid;
        border-color: grey;
        border-width: 1px;
        border-radius: 5px;
        width: 100%;
    }
    .alert {
        border-width: 2px;
        border-color: red;
    }
</style>